<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            {{ modalTitle }}
          </h2>
        </div>

        <div class="flex-shrink-0">
          <!-- <b-dropdown aria-role="list" position="is-bottom-left">
            <template #trigger="{ active }">
                <b-button
                    label="Acciones"
                    type="is-primary"
                    icon-pack="fas"
                    size="is-small"
                    :icon-right="active ? 'chevron-up' : 'chevron-down'" />
            </template>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('scheduled')">Recalcular progreso programado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('inspected')">Recalcular progreso inspeccionado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('all')">Recalcular todo</b-dropdown-item>
          </b-dropdown> -->
        </div>
      </header>

      <!-- BODY con fondo blanco liso -->
      <div class="px-6 py-5 space-y-4 bg-white">
        <component v-if="formComponent"
          ref="refFromComponent"
          :is="formComponent"
          :initial-data="formData"
          :activity-groups="activityGroups"
          :report-configs="reportConfigs"
          @epc-save="onSave"
          @epc-cancel="hide"
        />
      </div>

      <!-- FOOTER sin fondo gris, solo borde superior -->
      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-between space-x-2">
          <div v-if="!processingData"
            class="w-full flex items-center justify-between mb-2 mt-2">
            <v-button color="grey" icon="undo-alt" @click="isModalActive = false">{{ $t('cancel') }}</v-button>
            <v-button :disabled="disableSaveButton" type="button" icon="thumbs-up" icon-pack="far" class="mr-4" @click="submitForm">{{ $t('accept') }}</v-button>
          </div>

          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ConfigModal",

  components: {
  },

  props: {
    formComponent: { type: [Object, Function], default: null },
    formData: { type: Object, default: () => ( {} ) },
    modalTitle: { type: String, default: 'Configuración' },
    activityGroups: { type: Array, default: () => ( [] ) },
    reportConfigs: { type: Object, default: () => ( {} ) },
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,

      disableSaveButton: false,
      processingData: false,
    }
  },

  methods: {

    show() {
      this.isModalActive = true;
    },

    hide() {
      this.isModalActive = false;
      this.$emit('epc-close');
    },

    submitForm() {
      if (this.$refs.refFromComponent && this.$refs.refFromComponent.submit) {
        this.$emit('epc-saving');
        this.$refs.refFromComponent.submit();
      }
    },

    onSave() {
      this.isModalActive = false;
      this.$emit('epc-saved', this.reportConfigs);
    },
  }
};
</script>

<style scoped>

</style>
